<template>
  <div>
    <ColorSpace>
      <TopSection @mousedown="dragMouseDown" ref="select-area">
        <SelectArea data-aid="color-space-color-select">
          <!-- @click="setColor" -->
          <SelectorLayer
            class=""
            :style="`background-color: ${backgroundColor}`"
          ></SelectorLayer>
          <SelectorLayer class="saturation-layer"></SelectorLayer>
          <SelectorLayer class="brightness-layer"></SelectorLayer>
          <ColorIndicator
            class="dark-background"
            :style="{
              left: `${(hsv[1] / 100) * container_width - 7}px`,
              bottom: `${(hsv[2] / 100) * container_height - 7}px`,
            }"
          ></ColorIndicator>
        </SelectArea>
      </TopSection>
      <HueScale class="mt-gd-2">
        <HueIndicator
          :color="backgroundColor"
          type="range"
          min="0"
          max="360"
          class="slider"
          v-model="hsv_0"
        ></HueIndicator>
      </HueScale>
    </ColorSpace>
    <div class="d-flex mt-gd-2">
      <div
        class="select-color-display"
        :style="`flex: none; height: 24px; width: 24px; background-color: ${value};border-radius: 2px; border: 1px solid #eee;`"
      ></div>
      <b-form-input
        class="flex-grow-1"
        size="sm"
        v-model="displayValue"
      ></b-form-input>
    </div>
  </div>
</template>

<script>
import { hexToHsv, hsvToHex } from "@helpers/color.helper";
import {
  ColorSpace,
  TopSection,
  SelectArea,
  SelectorLayer,
  ColorIndicator,
  HueScale,
  HueIndicator,
} from "./ColorPickerTool.styled";

export default {
  props: {
    value: {
      default: "#ffffff",
      //   required: true,
      type: String,
    },
  },
  components: {
    ColorSpace,
    TopSection,
    SelectArea,
    SelectorLayer,
    ColorIndicator,
    HueScale,
    HueIndicator,
  },
  data() {
    return {
      hsv: [0, 0, 0],
      hsv_0: 0,
      container_height: 160,
      container_width: 160,
    };
  },
  computed: {
    backgroundColor() {
      return this.hsvToHex([parseInt(this.hsv[0]), 100, 100]);
    },
    displayValue: {
      get() {
        return this.value.slice(1, 7);
      },
      set(val) {
        if (val && val[0] != "#") {
          val = "#" + val;
        }
        val = val.slice(0, 7);
        const is_valid = /^#[0-9A-F]{6}$/i.test(val);
        if (is_valid) {
          this.hsv = this.hexToHsv(val);
        }
      },
    },
  },
  methods: {
    hexToHsv,
    hsvToHex,
    setColor(e) {
      const { x, y } = this.$refs["select-area"].$el.getBoundingClientRect();
      const { clientX, clientY } = e;
      let posX = clientX - x;
      let posY = clientY - y;
      let s = undefined;
      let v = undefined;
      if (posX < 0) {
        s = 0;
      } else if (posX > this.container_width) {
        s = 100;
      } else {
        s = 100 - ((this.container_width - posX) * 100) / this.container_width;
      }
      if (posY < 0) {
        v = 100;
      } else if (posY > this.container_height) {
        v = 0;
      } else {
        v = ((this.container_height - posY) * 100) / this.container_height;
      }

      this.hsv = [this.hsv[0], s, v];
    },

    dragMouseDown(e) {
      e = e || window.event;
      e.preventDefault();
      document.onmouseup = this.closeDragElement;
      document.onmousemove = this.elementDrag;
      this.setColor(e);
    },

    elementDrag(e) {
      e = e || window.event;
      e.preventDefault();
      this.setColor(e);
    },

    closeDragElement() {
      document.onmouseup = null;
      document.onmousemove = null;
    },
    detectOutOfFrame(e) {
      if(e.clientY <= 0 || e.clientX <= 0 || (e.clientX >= window.innerWidth || e.clientY >= window.innerHeight))
      {
        this.closeDragElement()
      }
    },
  },
  mounted() {
    this.hsv = this.hexToHsv(this.value);
    this.hsv_0 = this.hsv[0];
    document.addEventListener("mouseleave", this.detectOutOfFrame, { passive: true });
  },
  watch: {
    hsv() {
      this.$emit("input", this.hsvToHex(this.hsv).toUpperCase());
    },
    hsv_0() {
      this.hsv = [this.hsv_0, this.hsv[1], this.hsv[2]];
    }
  },
};
</script>

<style>
.select-color-display{
  margin-right: 16px;
}
/* input[type=”range”]::-webkit-slider-runnable-track{
  -webkit-appearance: none;
  border-radius: 6px !important;
}
input[type=”range”]::-moz-range-track{
 -webkit-appearance: none;
  border-radius: 6px !important;
}

input[type=”range”]::-ms-track{
 -webkit-appearance: none;
  border-radius: 6px !important;

} */
/* input[type="range"]::-moz-range-track {  
  background-color: #ccc;
  border-radius:30px;
  border:none;
    height: 100%;
}
input[type="range"]{
  -webkit-appearance: none;
  width: 100%;
  height: 8px;
  outline: none !important;
  appearance:none;
  border:none;
  border-radius:30px;
} */
</style>